<div class="rfr_input-wrapper">
  <ion-item style="position: relative;" lines="none" [style]="style" [class]="class" [ngClass]="{
              'rfr_ion-item': !readonly,
              'rfr_ion-item_read-only': readonly,
              'rfr_ion-item_error': !readonly && required && (error || (controlDir?.errors && controlDir?.control?.touched && controlDir?.control?.dirty)),
            }">
    <ion-input class="rfr_input" labelPlacement="floating" [type]="type" [value]="controlDir.control?.value"
      [clearOnEdit]="false"
      (input)="onChangeInput($any($event.target).value)" (ionBlur)="onBlur()" (ionFocus)="onFocus()"
      [disabled]="disabled" [readonly]="readonly" [placeholder]="placeholder" [pattern]="pattern" [min]="min"
      [max]="max" [maxlength]="maxLength">
      <div class="rfr-label-text" slot="label">{{ labelText }} <ion-text color="danger" *ngIf="required">*</ion-text></div>
    </ion-input>
    <div (click)="onShowPassword()" fill="clear" size="small" style="display: flex; align-items: center">
      <ion-icon style="font-size: 18px;" slot="icon-only"
        [name]="type != 'password' ? 'eye-off-outline' : 'eye-outline'">
      </ion-icon>
    </div>
  </ion-item>
  <ng-content select="[slot=error-message]"></ng-content>
  <div class="tooltip-password" *ngIf="validateTooltip && showTooltip" [@tooltipState]="tooltipState">
    <div *ngFor="let item of passwordValidations" class="tooltip-item">
      <ion-text>
        <ion-icon *ngIf="item.isValid" name="checkmark-outline" class="item-valid"></ion-icon>
        <ion-icon *ngIf="!item.isValid" name="close-outline" class="item-invalid"></ion-icon>
        <span [class]="item.isValid ? 'item-valid' : 'item-invalid'">{{ item.text | translate }}</span>
      </ion-text>
    </div>
  </div>
</div>
